//Menu desktop
  $('.megamenu .menu-dropdown .col-submenu.col-promo-banner').parents('.menu-dropdown-content').addClass('has-banner');
  //Check If menu not have level 3
  $('.menu-links.level2.no-child').each(function () {
    var liContent = $(this).find('ul li');
    if (liContent.length == '0') {
      $(this).addClass('no-element');
    }
  });
  //Check promo banner 
  $('.megamenu .menu-dropdown .col-submenu .menu-col').each(function () {
    var countLi = $(this).find('li.menu-links.level2');
    if (countLi.length > 4) {
      $(this).parent().addClass('not-show-banner');
    }
  });

  //Megamenu dobile
  if ($(window).width() < 992) {
    // Toggle slideout megamenu on mobile
    $(document).on('click', '.menu-drawer-container', function () {
      $('.megamenu').addClass('active');
      $('html').addClass('opening-megamenu');
      $('.go-sticky').addClass('active');
    });
    // Close menu mobile
    $(document).on('click', '.mobile-close-menu', function () {
      $('.megamenu').removeClass('active').removeClass('open-menu-lv1').removeClass('open-menu-lv2');
      $('html').removeClass('opening-megamenu');
      $('.megamenu').scrollTop(0);
      $('.megamenu .main-menu-item .menu-dropdown .dropdown-right-content').removeClass('mobile-active');
      $('.megamenu .main-menu-item .menu-dropdown').removeClass('mobile-active');
      $('.go-sticky').removeClass('active');
    });

    $(document).mouseup(function(e) {
        var menuContent = $(".bb-megamenu .megamenu.active");

        if (!menuContent.is(e.target) && menuContent.has(e.target).length === 0 && menuContent.hasClass('active'))
        {
          $('.megamenu').removeClass('active').removeClass('open-menu-lv1').removeClass('open-menu-lv2');
          $('html').removeClass('opening-megamenu');
          $('.megamenu').scrollTop(0);
          $('.megamenu .main-menu-item .menu-dropdown .dropdown-right-content').removeClass('mobile-active');
          $('.megamenu .main-menu-item .menu-dropdown').removeClass('mobile-active');
          $('.go-sticky').removeClass('active');
        }
    });

    // Toggle sub megamenu on mobile
    $(document).on('click', '.megamenu .main-menu-item.has-dropdown > a', function (e) {
      e.preventDefault();
      $('.megamenu').addClass('open-menu-lv1');
      $(this).parent().find('.menu-dropdown').addClass('mobile-active');
      $('.megamenu').scrollTop(0);
    });
    //Open menu level2
    $(document).on('click', '.menu-links.level2.has-submenu .menulv2', function (e) {
      e.preventDefault();
      $(this).next().slideToggle();
      $(this).toggleClass('active');
      $(this).parents('.menu-links.level2').siblings().find('.menu-sup').slideUp();
      $(this).parents('.menu-links.level2').siblings().find('.menulv2').removeClass('active');
    });
    //Back button
    $('.megamenu-mobile-top-title').on('click', function () {
      $('.megamenu').scrollTop(0);
      if ($('.megamenu').hasClass('open-menu-lv1')) {
        $('.megamenu').removeClass('open-menu-lv1');
      }
      var self = $(this);
      setTimeout(function () {
        self.parent().removeClass('mobile-active');
      }, 300);
    });
  }